import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <span className="text-xl font-semibold text-[#1A1208]">
              🏡 <span className="text-[#E8603C]">Realtor</span>ContentEngine
            </span>
          </div>

          {/* Center Navigation Links */}
          <div className="hidden md:flex items-center gap-8">
            <button
              onClick={() => scrollToSection('whats-included')}
              className="text-[#1A1208] hover:text-[#E8603C] transition-colors duration-200 text-sm font-medium cursor-pointer"
            >
              What's Inside
            </button>
            <span className="text-[#1A1208]/30">·</span>
            <button
              onClick={() => scrollToSection('templates')}
              className="text-[#1A1208] hover:text-[#E8603C] transition-colors duration-200 text-sm font-medium cursor-pointer"
            >
              Templates
            </button>
            <span className="text-[#1A1208]/30">·</span>
            <button
              onClick={() => scrollToSection('how-it-works')}
              className="text-[#1A1208] hover:text-[#E8603C] transition-colors duration-200 text-sm font-medium cursor-pointer"
            >
              How It Works
            </button>
          </div>

          {/* CTA Button */}
          <a
            href="https://consultix6.gumroad.com/l/realtor-content-engine"
            target="_blank"
            rel="noopener noreferrer"
            className="bg-[#E8603C] text-white px-6 py-3 rounded-full font-medium hover:bg-[#d55533] transition-all duration-200 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Get Instant Access — $29
          </a>
        </div>
      </div>
    </nav>
  );
}
